import { Components } from '@mui/material/styles';

const muiChipStyles: Components = {
  MuiChip: {
    styleOverrides: {
      root: {
        display: 'inline-flex',
        color: 'rgba(35, 35, 35, 0.80)',
        padding: '6px 8px',
        fontSize: '12px',
        fontWeight: 600,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '6px',
        border: '1px solid #D5D7E5',
        background: '#F8F9FD'
      }
    }
  }
};

export default muiChipStyles;
